import styled, { css } from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  background-color: ${color.white};
  border-radius: 12px;
  padding: 24px;
  cursor: ${(props) => {
    return props.cursor;
  }};
  .component_recap_card_icon_wrapper {
    border-radius: 90px;
    width: 52px;
    height: 52px;
    background-color: ${color.grey3};
    display: flex;
    align-items: center;
    justify-content: center;

    .anticon {
      font-size: 1.5em;
      color: ${color.black1};
    }

    ${(props) => {
      return (
        props.color === 'purple' &&
        css`
          background-color: ${color.purple6};

          .anticon {
            color: #6055cd;
          }
        `
      );
    }}

    ${(props) => {
      return (
        props.color === 'orange' &&
        css`
          background-color: ${color.orange6};

          .anticon {
            color: ${color.orange1};
          }
        `
      );
    }}

    ${(props) => {
      return (
        props.color === 'green' &&
        css`
          background-color: ${color.green6};

          .anticon {
            color: ${color.green1};
          }
        `
      );
    }}

    ${(props) => {
      return (
        props.color === 'grey' &&
        css`
          background-color: ${color.black6};

          .anticon {
            color: ${color.black3};
          }
        `
      );
    }}
  }
`;

export default Wrapper;
